import { useLocation } from 'react-router-dom'
import InfoDot from '../../help/InfoDot'
import { PAGE_INFO } from '../../help/content'
import { routeOf } from '../../help/dom'
import './NavLocation.css'

// Generic top bar of the nav column. Doubles as the header: pass a `title` for
// the simple case, or `children` for page-specific content (breadcrumb, search
// summary, etc.). Pages listed in the help content get an info dot that says
// what the page is for.
function NavLocation({ title, children, className }) {
  const { pathname } = useLocation()
  const info = PAGE_INFO[routeOf(pathname)]
  return (
    <div className={'nav-location' + (className ? ` ${className}` : '')}>
      {children != null ? (
        children
      ) : (
        <span className="nav-location-title">{title}</span>
      )}
      {info ? <InfoDot text={info} label="What is this page?" /> : null}
    </div>
  )
}

export default NavLocation
